import React from "react";
import { useBillsOn } from "./billsOn";
import "./billsTouch.css";

// Home page: one quiet line after the Newspapers row. Only for signed-in readers with Pay bills switched on.
const PATHS = [
  "M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zM11 18h2",
  "M5 12.5a10 10 0 0 1 14 0M8.5 16a5 5 0 0 1 7 0M2 9a15 15 0 0 1 20 0M12 20h.01",
  "M13 2 3 14h9l-1 8 10-12h-9l1-8z",
  "M3 7h18v12H3zM8 3l4 4 4-4",
];
export default function BillsStrip({ history }) {
  const on = useBillsOn();
  if (!on) return null;
  const go = (e) => { e.preventDefault(); if (history) history.push("/account/bills"); else window.location.href = "/account/bills"; };
  return (
    <div className="bt-strip">
      <a href="/account/bills" onClick={go}>
        <span className="bt-icons" aria-hidden="true">
          {PATHS.map((d) => <svg key={d} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d={d} /></svg>)}
        </span>
        <span className="bt-text"><strong>Pay bills on TheNewspaperStand</strong><small>Airtime, data, electricity and TV. Delivered in seconds.</small></span>
        <span className="bt-go">Pay a bill ›</span>
      </a>
    </div>
  );
}
